import { VersionFragment } from '@sketch/gql-types'

type PreviewFileDocument = Pick<
  NonNullable<VersionFragment['document']>,
  'previewFile'
>

export type PreviewFile = Pick<
  NonNullable<PreviewFileDocument['previewFile']>,
  'thumbnails'
>

export const thumbnailForPreviewFile = (
  previewFile: PreviewFile | null | undefined
) => {
  if (!previewFile?.thumbnails?.length) {
    return
  }

  const { thumbnails } = previewFile
  const largeThumbnail = thumbnails.find(
    thumbnail => thumbnail?.type === 'L'
  )?.url
  const fallbackThumbnail = thumbnails[0]?.url

  return largeThumbnail || fallbackThumbnail || undefined
}
